export default __webpack_public_path__ + "images/oral_health_coaching.7dfd61233ac1f76610d1f8aeb14fa077.svg";